import React, { Component } from "react";
import { connect } from "react-redux";
import { buildUrlFromParams } from "../../common/functions/url";
import WithAjax from "../../common/helpers/WithAjax";
import { clearVacancyCandidateSearchFields, validateVacancyCandidateSearchField } from "../../../actions/pages/vacancy-page";
import CandidateSearchResult from "./CandidateSearchResult";
import SingleLineSearchForm from "../../common/form/SingleLineSearchForm";
import InputField from "../../common/form/InputField";

class CandidateSearch extends Component {
  constructor() {
    super();
    this.onSearch = this.onSearch.bind(this);

    this.state = {
      items: [],
    };
  }

  componentDidMount() {
    this.props.clearVacancyCandidateSearchFields();
  }

  onSearch() {
    var searchTextField = this.props.vacancyCandidateSearchFields.find((el) => {
      return el.name === "SearchText";
    });

    let url = buildUrlFromParams("skillVendors", {
      searchText: searchTextField.value,
      skillTypes: this.props.skillType,
    });

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return (data[index].NavigationParam = data[index].Id);
      });
      this.setState({
        items: data,
      });
    });
  }

  render() {
    let fields = this.props.vacancyCandidateSearchFields;

    return (
      <div>
        <SingleLineSearchForm fields={fields} onSearch={this.onSearch}>
          <div className="col-5">
            <InputField field={fields[0]} validate={this.props.validateVacancyCandidateSearchField} />
          </div>
        </SingleLineSearchForm>
        <CandidateSearchResult items={this.state.items} vacancyId={this.props.vacancyId} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  vacancyCandidateSearchFields: state.vacancyCandidateSearch.fields,
});
const mapDispatchToProps = (dispatch) => ({
  clearVacancyCandidateSearchFields() {
    dispatch(clearVacancyCandidateSearchFields());
  },
  validateVacancyCandidateSearchField(value, field) {
    dispatch(validateVacancyCandidateSearchField(value, field));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAjax(CandidateSearch));
